export function uuid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  // prettier-ignore
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

export function concatClassName() {
  let className = '';
  const args = [].slice.call(arguments);

  args.forEach(string => {
    const s = string ? string + ' ' : '';
    className += s;
  });

  return className.trim();
}

export function formatPrice({ price, denom, round = 2 }) {
  if (!isNaN(price) && price != null) {
    const formatted = price.toFixed(round).replace(/./g, function(c, i, a) {
      return i && c !== '.' && (a.length - i) % 3 === 0 ? ',' + c : c;
    });
    return '$' + formatted;
  } else {
    return '--';
  }
}

export function parseQuery(str) {
  if (str) {
    return JSON.parse(
      '{"' +
        decodeURI(str.substring(1))
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    );
  } else {
    return {};
  }
}

export function alignFixedHeaderTable(id, height) {
  const $tables = document.querySelectorAll(`#${id} table`);
  if ($tables.length) {
    const $headerWrapper = $tables[0].parentElement;
    let $bodyWrapper = $tables[1].parentElement;
    $bodyWrapper.style.maxHeight = height;
    setTimeout(() => {
      if ($bodyWrapper.scrollHeight > $bodyWrapper.offsetHeight) {
        $headerWrapper.classList.add('scrollbar-adjust');
      }
    });
  }
}

export function formatDate(date, includeTime) {
  if (!date) {
    return;
  }
  if (typeof date !== 'object') date = new Date(date);

  const str = date.toDateString();
  let strArr = str.split(' ');
  const year = strArr.pop();
  strArr[strArr.length - 1] = strArr[strArr.length - 1] + ',';
  strArr.push(year);
  let dateFormatted = strArr.join(' ');
  if (includeTime) {
    let timeString = date.toLocaleTimeString();
    let period = timeString.includes('PM') ? 'pm' : 'am';
    let arr = timeString.split(':');
    arr.pop();
    dateFormatted += ` ${arr.join(':') + period}`;
  }
  return dateFormatted;
}

export const addAutofillListeners = () => {
  const inputs = document.querySelectorAll('input');

  for (var i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('animationstart', _checkAutofill, false);
  }
};

export const removeAutofillListeners = () => {
  const inputs = document.querySelectorAll('input');

  for (var i = 0; i < inputs.length; i++) {
    inputs[i].removeEventListener('animationstart', _checkAutofill, false);
  }
};

export const snakeToCamel = s => {
  return s.replace(/(_\w)/g, m => {
    return m[1].toUpperCase();
  });
};

const _checkAutofill = ({ target, animationName }) => {
  switch (animationName) {
    case 'onAutoFillStart':
      return target.parentElement.classList.add('hide-label');
    case 'onAutoFillCancel':
      return target.parentElement.classList.remove('hide-label');
    default:
  }
};

export function idealTextColor(hex) {
  if (hex) {
    let nThreshold = 105;
    let components = getRGBComponents(hex);
    let bgDelta =
      components.R * 0.299 + components.G * 0.587 + components.B * 0.114;

    return 255 - bgDelta < nThreshold ? '#000000' : '#ffffff';
  } else {
    return '#000000';
  }
}

function getRGBComponents(hex) {
  var r = hex.substring(1, 3);
  var g = hex.substring(3, 5);
  var b = hex.substring(5, 7);

  return {
    R: parseInt(r, 16),
    G: parseInt(g, 16),
    B: parseInt(b, 16)
  };
}



// WEBPACK FOOTER //
// ./src/util/baseUtil.js